import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useParams } from "react-router-dom";
import './index.scss';

import Loading from '../../common/Loading';
import TextareaCounter from './../../FormComponents/TextareaCounterTop';
import FileUpload from './FileUpload'; 
import helper from '../../Conversations/helpers';


class AddCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openFileModal: false,
      template:'',
      name:'',
      editmode:false,
      editname:false,
      allowedit:true,
      readytosend:false,
      nameerror:false,
      messagewarning:false,
      error:false,
      errormessage:'',
      preview:false,

    };
  }

  getBusinessPhoneNumber = () =>{
      if(this.props.carriers.phoneNumber){
        return helper.formatPhoneNumber(this.props.carriers.phoneNumber);
      }else{
        return '<your business number>';
      }
  } 

  getBusinessName = () =>{
    if(this.props.business.info.BUSINESS_NAME){
      return this.props.business.info.BUSINESS_NAME;
    }else{
      return '<your business name>';
    }
} 

  componentDidMount =()=>{
    const { match: { params } } = this.props;
    if(params.id){
      this.props.getCampaignOutreach(this.props.business.id,params.id);
      this.setState({
        editmode:true
      })
    }else{
      let sms_limit_error = this.props.outreach.outreaches.sms_limit*0.9<this.props.outreach.outreaches.total_messages_sent_for_month;
      this.setState({
        name:this.props.outreach.outreachname,
        messagewarning:sms_limit_error,
        template: "Thanks for being loyal to "+this.getBusinessName()+". Receive 50% off your next service with code FIFTYOFF. Call "+this.getBusinessPhoneNumber()+" to book!"
      })
    }
  }
 
  componentWillReceiveProps(nextProps){

    if(nextProps.outreach.getCampaign!==true && nextProps.outreach.getCampaign!==this.props.outreach.getCampaign){
      let sms_limit_error = nextProps.outreach.outreaches.sms_limit*0.9<nextProps.outreach.outreaches.total_messages_sent_for_month;
      sms_limit_error = ( nextProps.outreach.campaign.contacts_count > (nextProps.outreach.outreaches.sms_limit -nextProps.outreach.outreaches.total_messages_sent_for_month));
      this.setState({
        template:nextProps.outreach.campaign.template,
        name:nextProps.outreach.campaign.name,
        allowedit:this.disbleEdit(nextProps.outreach.campaign.status),
        openFileModal:nextProps.outreach.fileupload,
        editmode:true,
        messagewarning:sms_limit_error,
        error:nextProps.outreach.apierror,
        errormessage:nextProps.outreach.message
      })
    }
  }
  
  fileUploadModal = ()=>{
    if(this.state.name.length>0 && this.state.template.length>0 ){
    if(!this.state.editmode){
      this.setState({
        editmode:true
      },this.createOutreachCampaign(false))
    }else{
      this.createOutreachCampaign(false)
    }
    }else{
      this.setState({
        error:true,
        errormessage:"Name and Template can't be empty"
      })
    }
  }

  fileUploadModalclose= ()=>{
    this.setState({
      openFileModal:false,
      preview:false
    })
    this.props.closeFileModal();
  }
  
  createOutreachCampaign = (exit,send)=>{
    let params ={};
    if(!this.state.editmode){
     params={
      business_id:this.props.business.id,
      name:this.state.name,
      template:this.state.template
    }}
    else{
      params = {...this.props.outreach.campaign};
      delete params.created_time;
      delete params.updated_time;
      params.name = this.state.name;
      params.template = this.state.template;
    }
    console.log(params);
    this.props.createCampaign(params,!this.state.editmode,this.props,exit,send);
  }

  templatechange = (event)=>{
    console.log(event);
    if(event.target.value.trim().length>0){
    this.setState({template:event.target.value,error:false})
    }else{
      this.setState({
        template:event.target.value,
        error:true,
        errormessage:"Name and Template can't be empty"
      })
    }
  }

  saveAndExit =()=>{
    if(this.state.allowedit){
    if(this.state.name.trim().length>0 && this.state.template.trim().length>0){
    this.setState({
      editmode:true},this.createOutreachCampaign(true))
    // this.props.history.goBack()
    }else{
      this.setState({
        error:true,
        errormessage:"Name and Template can't be empty"
      })
    }
  }else{
    this.props.history.goBack();
  }
  }
  nameChange =(event)=>{
    if(event.target.value.trim().length>0){
      this.setState({name:event.target.value,error:false,nameerror:false})
    }else{
      this.setState({name:event.target.value, nameerror:true})
    }
  }
  removeContacts = (id,fileupload)=>{
    // let showmodal= false;
    // if(fileupload){
    //   showmodal = true;
    // }
    console.log("fileupload",fileupload)
    this.props.deleteContact(this.props.business.id,id,(fileupload?true:false))
  }
  addContacts =(contacts,name)=>{
    this.props.postContact(this.props.business.id,this.props.outreach.campaign.id,contacts,name)
  }

  sendCampaign = ()=>{
    console.log(this.props.outreach.campaign,this.state)
    if(this.props.outreach.campaign.name===this.state.name && this.props.outreach.campaign.template===this.state.template){
      this.props.postCampaign(this.props.business.id,this.props.outreach.campaign.id,this.props);
    }else{
      this.createOutreachCampaign(true,this.props.outreach.campaign.id);
    }
  }
  disbleEdit=(status)=>{
    switch(status){
      case 'IN_PROGRESS': return false;
      break;
      case 'PUBLISHED': return false;
      break;
      case 'CREATED': return true;
      break;
      default: return true;
    }
  }
  editName =()=>{
    if(this.state.allowedit){
      setTimeout(()=>{document.getElementById('name-input').focus();},100)
      this.setState({editname:true}
        );
      }
  }
  removeFocus =()=>{
    this.setState({editname:false}
      );
  }

  sendAbled =()=>{
    const {outreach} =this.props;
    const {campaign} = outreach;
    if(this.state.allowedit && this.state.template.trim().length>0&& campaign && campaign.contacts && campaign.contacts.length>0 && !this.state.nameerror){
      console.log(campaign.contacts_count , outreach.outreaches.sms_limit ,outreach.outreaches.total_messages_sent_for_month)
      if(campaign.contacts_count > (outreach.outreaches.sms_limit -outreach.outreaches.total_messages_sent_for_month)){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }
  allowContactUpload = ()=>{
    if(this.state.allowedit && this.state.template.trim().length>0 && !this.state.nameerror){
      return false;
    }else{
      return true;
    }
  }
  filePreviewModal =() =>{
    console.log('preview',this.state)
    this.setState({
      preview:true,
    })
    setTimeout(()=>this.setState({
      openFileModal:true
    }),10)
  }
  render() {
    const {openFileModal, template, editmode, name, editname, allowedit,errormessage,error} = this.state;
    const {outreach} =this.props;
    const {campaign,outreaches} = outreach;
    console.log('campaign',this.state)
    return (
      <div className="add-campaign">
        {(editmode && outreach.getCampaign===true) && 
        <div className="add-campaign_loader">
        <Loading />
        </div>
        }
        {((editmode && outreach.getCampaign!==true)||!editmode) &&
        <div className='add-campaign_title'>
          <div className="add-campaign_title_content">
              <div className="title" onClick={this.saveAndExit}>
                  <span className="material-icons">arrow_back</span>
                  <span className="back-text">Save and exit</span>
              </div>
          </div>
          <div className="add-campaign_title_meta">
            <div className="name" ><input id="name-input" className={classnames('input-name',{'focus-input':this.state.editname})}  onBlur={this.removeFocus} value={name} onChange={this.nameChange} disabled={!editname} minLength="1" maxLength="100"/><i onClick={this.editName} class="material-icons">edit</i></div>
            <div className="actions">
                  {/* <button className="schedule" onClick={this.closeModal}>Schedule</button> */}
                  <button disabled={this.sendAbled()} className="send" style={{opacity:(this.sendAbled()?0.5:1)}} onClick={this.sendCampaign}>Send</button>
              </div>
          </div>
        </div>
        }
        {((editmode && outreach.getCampaign!==true)||!editmode) &&
        <div className="add-campaign_campaign">
          <div className="add-campaign_campaign_content">
            <div className="message">
              <div className="title">Content</div>
              <div className="label">YOUR OUTREACH TEXT MESSAGE</div>
              <TextareaCounter
              rows="3"
              name="campaign_message"
              value={template}
              onChange={this.templatechange}
              maxLength={140}
              className="text"
              disabled={!allowedit}
              />
            <div className="note"><span>Note:</span> TrueLark will add the following opt-out message at the end of your message above — 'Reply STOP to optout'</div>
            </div>
            <div className="recipients">
                <div className="title">Recipients</div>
                {campaign && campaign.contacts && campaign.contacts_count>0?
                (<div>
                  <button className="btn btn--secondary btn--lg csv-remove" onClick={this.filePreviewModal}>
                <i className="material-icons">person</i><span>{campaign.contacts_count}</span><span>contacts imported</span>
                </button>
                {allowedit && 
                <button  disabled={!allowedit} className="btn btn--link button-cancel csv-cancel" onClick={()=>this.removeContacts(campaign.id)}>Remove</button>
                }
                </div>
                ):
                (
                <div>
                <div className="label">You don’t have any contacts. Let’s add some people!</div>
                <button className="btn btn--secondary btn--lg csv-import" onClick={this.fileUploadModal} disabled={this.allowContactUpload()}>
                <i className="material-icons">cloud_upload</i>Import a csv file 
                </button>
                </div>)
                }
                {error && <div className="errormessage">{errormessage}</div> }
                {outreaches && this.state.messagewarning &&<div className="errormessage"> You only have <span>{outreaches.sms_limit-outreaches.total_messages_sent_for_month}</span> messages left to send in the current month </div>}
                <FileUpload 
                    openFileModal={openFileModal} 
                    fileUploadModalclose={this.fileUploadModalclose} 
                    addContacts={this.addContacts} 
                    removeContacts={this.removeContacts} 
                    outreach={outreach} 
                    business={this.props.business} 
                    preview={this.state.preview}
                />
            {this.props.business && this.props.business.info &&
            <div className="note">{this.props.business.info.BUSINESS_NAME} bears full responsibility for complying with Telephone Consumer Protection Act (TCPA) and any other rules and regulations in the local jurisdiction related to SMS-based promotional and transactional messaging.</div>
            }
            </div>
            <div className="divider"></div>
            <div className="csv-help">
              <span>Need help?</span>
              <span className="read-more"><a href={window.Config.OUTREACH_CONFIG.CSV_HELP} target='_blank'>See our guide</a></span>
              <span>on how to prepare your spreadsheet for import</span>
          </div>
          </div>
          </div>
          }
      </div>
    );
  }
}
export default AddCampaign;
